import { UserState } from './types';

export function isloggedIn(state: UserState) {
  return state.loggedIn;
}

